module.exports = __webpack_public_path__ + "static/media/approved.2de28360.png";